export default "__VITE_ASSET__BHigNVVg__"